import { styled as t, Box as r, Typography as p, useMediaQuery as h } from "@mui/material";
import f from "../../assets/logo.png.js";
import { LOGIN_SLIDE_STATE as m } from "../../constants/login.js";
import x from "../components/ConnectWalletButton.js";
import u from "../elements/CommunityAuthSection.js";
import w from "../elements/EmailLoginComponent.js";
import L from "../elements/LoginAgreement.js";
import k from "../../../temp-lib/components/account/adeptus/AdeptusCodeInput.js";
import C from "../../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import b from "../../../temp-lib/components/share/next/Image.js";
import { AdeptusInputMode as S } from "../../../temp-lib/constants/adeptus.js";
import y from "../../../temp-lib/styles/theme.js";
import { isIosOrAndroid as T } from "../../../temp-lib/util/browser/index.js";
import { useCallback as l } from "react";
import { useTranslation as A, Trans as I } from "react-i18next";
import { useSwiper as E } from "swiper/react";
import { jsxs as N, jsx as o } from "react/jsx-runtime";
const z = t(r)`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 680px;
  position: relative;
  background-color: #1c1f25;
  ${(i) => i.theme.breakpoints.up("res1024")} {
    padding: 40px;
    width: 560px;
    overflow-y: auto;
  }
  ${(i) => i.theme.breakpoints.between("res480", "res1024")} {
    padding: 40px;
    width: 100%;
  }
  ${(i) => i.theme.breakpoints.down("res480")} {
    padding: 40px 12px;
    width: 100%;
  }
`, B = t(b)`
  width: 151px;
  min-height: 151px;
  height: 36px;
  min-height: 36px;
`, _ = t(p)`
  font-size: 28px;
  font-weight: 700;
`, j = t(p)`
  font-size: 12px;
`, D = t(p)`
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-top: 4px;
`, G = t(r)`
  display: flex;
  gap: 10px;
`, M = t(r)`
  border-top: 1px dashed #979797;
  margin: 16px 0px;
  width: 100%;
`, O = t(C)`
  color: #3682eb;
  font-size: 12px;
`, W = t(k)`
  margin-bottom: 16px;
  width: 100%;
`, io = (i) => {
  const {
    className: a,
    onRoninLogin: s
  } = i, n = E(), {
    t: e
  } = A(), c = h(y.breakpoints.down("res1024")), d = l(() => {
    n.slideTo(m.SIGN_UP);
  }, [n]), g = l(() => {
    T() && !window.ronin || window.okxwallet ? n.slideTo(m.SELECT_WALLET) : s();
  }, [s, n]);
  return /* @__PURE__ */ N(z, {
    className: a,
    children: [!c && /* @__PURE__ */ o(B, {
      src: f
    }), /* @__PURE__ */ o(_, {
      children: e("login.email.title")
    }), /* @__PURE__ */ o(j, {
      children: e("login.email.subtitle")
    }), /* @__PURE__ */ o(w, {}), /* @__PURE__ */ o(D, {
      children: /* @__PURE__ */ o(I, {
        components: {
          lnk: /* @__PURE__ */ o(O, {
            onClick: d
          })
        },
        children: e("login.email.signup")
      })
    }), /* @__PURE__ */ o(M, {}), /* @__PURE__ */ o(G, {
      children: /* @__PURE__ */ o(x, {
        onClick: g
      })
    }), /* @__PURE__ */ o(u, {}), /* @__PURE__ */ o(W, {
      showFoot: !1,
      mode: S.AccountLogin
    }), /* @__PURE__ */ o(L, {})]
  });
};
export {
  io as default
};
//# sourceMappingURL=RootLoginSection.js.map
